import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { HeaderListSkeleton } from '../HeaderListSkeleton';
import { ListSkeleton } from '../ListSkeleton';

/**
 * Skeleton affiché pendant le chargement initial du dashboard des offres.
 */
export const OfferDashboardSkeleton: React.FunctionComponent = function () {
    const tabKey = (index: number): string => `tab-${index}`;

    return (
        <Box sx={{ overflow: 'hidden' }}>
            <Skeleton
                variant="text"
                width={400}
                height={48}
                sx={{ marginBottom: 2 }}
            />

            <Box sx={{ display: 'flex', gap: 2, marginBottom: 3 }}>
                {Array.from({ length: 6 }).map((_, index) => (
                    <Skeleton
                        key={tabKey(index)}
                        variant="rounded"
                        width={100}
                        height={40}
                    />
                ))}
            </Box>

            <HeaderListSkeleton />
            <ListSkeleton
                showSearch
                showPreview
                columns={5}
                rows={8}
            />
        </Box>
    );
};
